import { render } from "./CaribeCoolerView.vue?vue&type=template&id=798901f0"
import script from "./CaribeCoolerView.vue?vue&type=script&lang=js"
export * from "./CaribeCoolerView.vue?vue&type=script&lang=js"

import "./CaribeCoolerView.vue?vue&type=style&index=0&id=798901f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__